import { oc } from '@orpc/contract';
import { createTargetInputSchema, targetSchema } from '../schemas/targets.schemas.js';
export const createTargetContract = oc
    .route({
    method: 'POST',
    path: '/targets',
    tags: ['Targets'],
    summary: 'Create a target linked to unit-compatible KPIs; 409 naming the conflicting target when an active period would overlap (ADMIN, PM)',
})
    .input(createTargetInputSchema)
    .output(targetSchema);
//# sourceMappingURL=create-target.contract.js.map